module.exports = __webpack_public_path__ + "static/PP5-962cefb3bdda89385f750366a14504b4.jpg";